export default {
    groupId: null,
    type: null,
    status: null,
    secondary_status: null,
    taxRate: null,
    supplier: null,
    description: '',
    duration: {
        enabled: false,
        time: {
            enabled: false,
            start: '',
            end: '',
        },
        quantity: {
            value: 1,
            unit: '',
        },
    },
    has_cost_quantity: false,
    cost_quantity: null,
    quantity: {
        value: 1,
        unit: '',
    },
    is_quantity_per_head: false,
    unit_cost: {
        currency: null,
        value: '0.00',
    },
    unit_price: {
        currency: null,
        value: '0.00',
        unit: '',
    },
    unit_cost_local: {
        currency: null,
        value: '0.00',
    },
    unit_price_local: {
        currency: null,
        value: '0.00',
        unit: '',
    },
    discount: {
        value: '',
        fixed: false,
    },
    commission: {
        value: '',
        fixed: false,
        type: 'receivable',
    },
    management_fee: 0,
    resources: [],
    billable: true,
    vatable: true,
    notes: '',
    transaction_type: null,
    fee_tax_rate_id: null,
};
